import { useScreenHeight } from '../hooks/use-screen-height';
import { cn } from '../utils/cn';

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  variant?: 'large' | 'medium' | 'small';
  className?: string;
}

export const Spinner = ({
  variant = 'medium',
  className,
  ...props
}: SpinnerProps) => {
  const size = getSizeFromVariant(variant);

  return (
    <div role="status">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn('animate-spin', 'text-l-green-400 ', className)}
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span className="sr-only">Carregando...</span>
    </div>
  );
};

export function CenteredSpinner() {
  const height = useScreenHeight();

  return (
    <div className={`flex items-center justify-center ${height}`}>
      <Spinner />
    </div>
  );
}

function getSizeFromVariant(
  variant: NonNullable<SpinnerProps['variant']>,
): number {
  switch (variant) {
    case 'large':
      return 48;
    case 'medium':
      return 32;
    case 'small':
      return 16;
  }
}
